<template>

	<div class="area">
	    <div class='authority' v-if='status==true'>
		<div class='content'>
			<p>您没有权限查看页面</p>
		   <p>如需开通请联系系统管理员</p></div>

		</div>
		<div v-else >
	    <div class="box">
                    <p class="return" @click="backa">返回首页</p>
                    <span class="line">|</span>
                    <p class="contract">消息中心</p>
                    
                </div>
		<div class="p_btn">
	      <div>
		     <div class="mainTitle">消息中心</div>
		  </div>
		</div>
        <div class="messa">
            <el-badge :value="wdtotal" class="item" >
				 未读消息
		    </el-badge>
        </div>
		<div class="message_content">
										<div class="message_section" v-for="(v,k) in messageList" :key="k">
											<div class="message_topContent">
												<el-badge is-dot class="item" v-if="v.status == 1">
													<img src="../../assets/img/system_notice.png" alt="" class="message_icon">
													<!-- <img src="../../assets/img/system_msg.png" alt="" class="message_icon" v-if="v.type == 2"> -->
													<!-- <img src="../../assets/img/system_announcement.png" alt="" class="message_icon" v-if="v.type == 3"> -->
												</el-badge>
												<img v-else src="../../assets/img/system_disable.png" alt="" class="message_icon" >
												<!-- <img src="../../assets/img/system_msg.png" alt="" class="message_icon" v-if="v.status != 1 && v.type == 2"> -->
												<!-- <img src="../../assets/img/system_announcement.png" alt="" class="message_icon" v-if="v.status != 1 && v.type == 3"> -->
												<div class="message_type"  v-if="v.status == 1">
													<div class="system_name">
														<span>通知</span>
														<span>{{v.create_time}}</span>
													</div>
													<div class="message_title">{{v.title}}</div>
											        <div class="message_text" v-html="v.content"></div>

												</div>
												<div class="message_type1"  v-if="v.status != 1">
													<div class="system_name">
														<span>通知</span>
														<span>{{v.create_time}}</span>
													</div>
													<div class="message_title">{{v.title}}</div>
											        <div class="message_text" v-html="v.content"></div>

												</div>
											</div>
										</div>
									</div>
										<div class="bgnull" v-if="messageList.length==0">
										<div class="bg"></div>
										<div class="span">
											暂无消息
										</div>
									</div>
		<page :pagesize="pageSize" :total="total" @currentChange="cur" @enter="cur" v-show="total>0" :pageNum="pageNum"></page>
	    </div>
	</div>
</template>

<script>
	export default {
		created() {
			//初始化数据
			this.loadData() 
		},
		data() {
			return {
                messageList:[],
				status:false,
                wdtotal:0,
				pageNum: 1,
				pageSize: 10,
				total: 0,
				ids:'',
				idss:[]
				
				
			
			}
		},
		methods: {
		backa(){
         

			 this.$router.push({path: '/main'})

		},
			// 加载列表
			loadData() {
				const params = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				};
				return this.$axios.get('person/queryNoticeList', {
					params
				}).then(res => {
					if(res.data.status==1){
					  this.total = res.data.data.total;
					  this.wdtotal = res.data.wdtotal
					  this.messageList = res.data.data.list

					   for(var i =0;i<this.messageList.length;i++){
                          if(this.messageList[i].status==1){
						  this.ids += this.messageList[i].id+',';
						  var str=this.ids.substring(0,this.ids.length-1)
                          }
					}
					if(str){
					this.idss = str.split(',')
					}
					
                    if(this.ids == ''){
						return
					} 
					
					   this.$axios.post('person/updateNoticeStatusById?ids='+this.ids
				              ).then(res => {
					
				               }).catch(err => {
				//处理错误
					console.error(err)
				})

					
					}
					
				
						
					
				}).catch(err => {
					//处理错误
					console.error(err)
				})
			},
			//分页方法
			cur(val) {
				this.pageNum = val;
				this.loadData();
			},
			
		},
	
	}
</script>

<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../assets/css/common/table.less" scoped lang="less"></style>
<style scoped lang="less">
	.tab_nav {
		border-bottom: none;
	}

	.form {
		margin: 23px 0;
	}

	.el-form-item {
		margin-bottom: 15px;
	}

	.span_bgc {
			padding: 3px 5px;
		background:rgba(254,240,240,1);
border-radius:4px;
border:1px solid rgba(252,210,210,1);
		font-size:12px;
font-weight:400;
color:rgba(245,116,116,1)
	}



	.span_bgc4 {
	padding: 3px 5px;
		background:rgba(234,255,248,1);
		font-size:12px;
font-weight:400;
color:rgba(59,199,152,1);
border-radius:4px;
border:1px solid rgba(183,225,211,1);
	}
	 .box {
                display: flex;
                margin-top: 20px;

                .return {
                    font-size: 12px;
                    font-weight:400;
                    color:rgba(102,105,227,1);
                    margin-right: 20px;
                    cursor: pointer;
                }

                .line {
                    margin-right: 20px;
                    color: #606266
                }

                .lines {
                    margin-right: 20px;
                    color: #606266;
                    font-weight: bold;
                }

                .contract {
                    margin-right: 20px;

                    font-size: 12px;
                    font-weight:400;
                    color:rgba(138,138,154,1);
                }
            }
			 .mainTitle{
                font-size:24px;
                font-weight:bold;
                color:rgba(48,49,64,1);
                margin:33px 0 14px 0;
            }
			.smallTitle{
				font-size:12px;
                font-weight:400;
                color:#303140;
			}
            .filter{
                width:100%;
                height:57px;
                background:rgba(242,245,248,1);
                border-radius:4px;
                margin-bottom:30px;
				.content{
					display:flex
				}
				size{
					font-size:12px;
font-weight:400;
color:rgba(84,85,102,1);
margin-left:10px
				}
            }
			.authority{
				width:100%;
				height:100%;
				display: flex;
                justify-content: center;
				.content{
					text-align:center;
					margin: 50px auto;
                   font-size: 24px;
				   font-weight:bold;
				   color: #303140;
					
				}
				
            }
            .message_content{
				
					.message_section{
						padding:15px 0;
						border-bottom: 1px solid #e9eff4;
						.message_topContent{
							display:flex;
							margin-bottom: 12px;
							.message_icon{
								width:40px;
								height:40px;
								padding-top: 3px;
							}
							.message_type{
								width:100%;
								font-size:12px;
                                padding-left:14px;
                                font-weight:400;
                                color:rgba(84,85,102,1);
								.system_name{
									padding-bottom: 5px;
									display: flex;
									justify-content: space-between;
								}
								.message_title{
									font-size:12px;
                                    font-weight:bold;
                                     color:rgba(48,49,64,1);
                                }
                                .message_text{
							font-size:12px;
                            font-weight:400;
                            color:rgba(48,49,64,1);
							padding-bottom:15px;
						}
							}

							.message_type1{
								width:100%;
								font-size:12px;
                                padding-left:14px;
                                font-weight:400;
								color:rgba(84,85,102,1);
								opacity: 0.5;
								.system_name{
									padding-bottom: 5px;
									display: flex;
									justify-content: space-between;
								}
								.message_title{
									font-size:12px;
                                    font-weight:bold;
									 color:rgba(48,49,64,1);
								    opacity: 0.5;
									 
                                }
                                .message_text{
							font-size:12px;
                            font-weight:400;
                           color:rgba(48,49,64,1);
							padding-bottom:15px;
								opacity: 0.5;

						}
							}
						}
						
						.message_check{
							color: #6669e3;
							font-size: 14px;
							text-align:right;
							padding-left:64px;
							cursor: pointer;
						}
					}
					.message_section:last-child{
						border:none;
					}
                }
                .messa{
                    font-size:12px;
                    font-weight:bold;
                    color:rgba(84,85,102,1);
                    width: 57px;
				}
				.bgnull {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		
			.bg {
				width: 237px;
				height: 109px;
				background-image: url(../../assets/img/10wvB0eE.png);
				background-position: center;
				background-repeat: no-repeat;
				background-size: 237px 109px;
				margin-top: 100px;
			}
		}
</style>
